import { useParams } from 'react-router';

import { useEffect, useState } from 'react';

import {
  ScenarioDetailsContext,
  useGetGuestAiReviewDetailsQuery,
  useGetScenarioQuery,
  SimulationContext,
} from '@app-velocity/modules/scenarios';
import { Skeleton } from '@app-velocity/ui';

import { SimulationContent } from '../components/SimulationContent';

export const SimulationGuest = () => {
  const [reviewIsCompleted, setReviewIsCompleted] = useState(false);
  const { scenarioId, workspaceId, reviewId } = useParams<{
    scenarioId: string;
    workspaceId: string;
    reviewId: string;
  }>();

  const { data: scenario } = useGetScenarioQuery(
    workspaceId || '',
    scenarioId || '',
    'guest'
  );

  const { data: review } = useGetGuestAiReviewDetailsQuery(
    scenario?.shareToken,
    reviewId || '',
    !reviewIsCompleted
  );

  useEffect(() => {
    if (review && review.reviewStatus !== 'IN_PROGRESS') {
      setReviewIsCompleted(true);
    }
  }, [review]);

  if (!scenario) return <Skeleton height={58} margin="0" borderRadius={0} />;

  return (
    <SimulationContext.Provider
      value={{
        mode: 'guest',
        scenario,
        review,
      }}
    >
      <ScenarioDetailsContext.Provider
        value={{
          scenario: scenario,
        }}
      >
        <SimulationContent />
      </ScenarioDetailsContext.Provider>
    </SimulationContext.Provider>
  );
};
